import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import Autocomplete from "react-google-autocomplete";
import { setPlace } from '../../../Redux/Action/Action';
import thingsbg from '../../../assets/images/things-bg.png'
import museum from '../../../assets/images/museum_img.jpg'
import shopping from '../../../assets/images/ecommerce-online-shop-euro.jpg'
import topAttration from '../../../assets/images/top_attra_img.jpg'
import dayTrip from '../../../assets/images/dayTrip.jpg'
import fineDining from '../../../assets/images/fineDining.jpg'
import siteseeing from '../../../assets/images/sightsing.jpg'
import search from '../../../assets/images/search.svg'

export default function ThingsToDoBanner() {
    const toTitleCase = (str) => {
        return str
            .replace(/-/g, ' ')
            .toLowerCase()
            .replace(/\b\w/g, (char) => char.toUpperCase());
    };

    const getTitleFromUrl = () => {
        const path = window.location.pathname;
        const segments = path.split('/').filter(Boolean);

        const secondLast = segments[segments.length - 2];

        if (!secondLast) return "Things To Do";

        return toTitleCase(secondLast);
    };
    var url;
    const title = getTitleFromUrl();
    if(title === "Things To Do"){
        var url = thingsbg
    }else if(title === "Museum"){
        var url = museum;
    }else if(title === "Shopping"){
        var url = shopping;
    }else if(title === "Top Attractions"){
        var url = topAttration;
    }else if(title === "Day Trip"){
        var url = dayTrip;
    }else if(title === "Fine Dining"){
        var url = fineDining;
    }else if(title === "Sightseeing"){
        var url = siteseeing;
    }else{
        var url = thingsbg;
    }
    const place = useSelector((state) => state.place);
    const dispatch = useDispatch()
    const localSelectedCity = localStorage.getItem('selectedCity');
    return (
        <section className="section-equal-padding hotel-hero-sec uk-scrollspy-inview"
            style={{ backgroundImage: `url(${url})`, backgroundRepeat: "no-repeat", backgroundSize: "cover" }}
            uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
            <div className="container">
                <div className="slider-content text-center mx-auto">
                    <h1>{title}</h1>
                </div>
                <div className="search-wrapper flight-search-wrpaaer bg-white d-block">
                    <div className="flight-booking-form">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="search-item">
                                    <label className="form-label">Search for a city or place</label>
                                    <div
                                        className="search-control-wrapper input-group custom-input d-flex align-items-center gap-2">
                                        <img src={search} alt="search" />
                                        <Autocomplete
                                            className="shadow-none border-0 form-control outline-0 p-0 px-2"
                                            apiKey="AIzaSyDrSVPFOzjxmlv2WLSnfJ0ARrmYP9QDajs"
                                            placeholder={
                                                localSelectedCity && localSelectedCity !== "undefined" && place
                                                    ? place.replace(/\b\w/g, (x) => x.toUpperCase())
                                                    : "Where would you like to go"
                                            }

                                            onPlaceSelected={async (city) => {
                                                const selectedCity = city.formatted_address.split(",")[0].toLowerCase();
                                                // // Dispatch Redux actions
                                                dispatch(setPlace(selectedCity));
                                                localStorage.setItem('selectedCity', city.formatted_address.split(',')[0]);
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
